export const getTitleCase = (text: string, excluded?: string[]) => {
  return text?.replace(/\w\S*/g, function (word) {
    if (excluded?.includes(word)) return word;
    return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
  });
};
